/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Public_DomainInputs */

const en_val_public_domain = /** @type {(inputs: Val_Public_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public Domain`)
};

const es_val_public_domain = /** @type {(inputs: Val_Public_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dominio público`)
};

const fr_val_public_domain = /** @type {(inputs: Val_Public_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domaine public`)
};

const de_val_public_domain = /** @type {(inputs: Val_Public_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemeinfrei (Public Domain)`)
};

const ja_val_public_domain = /** @type {(inputs: Val_Public_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パブリックドメイン`)
};

const zh_val_public_domain = /** @type {(inputs: Val_Public_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公共领域`)
};

const ar_val_public_domain = /** @type {(inputs: Val_Public_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملكية عامة`)
};

const id_val_public_domain = /** @type {(inputs: Val_Public_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domain Publik`)
};

const it_val_public_domain = /** @type {(inputs: Val_Public_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dominio Pubblico`)
};

const ru_val_public_domain = /** @type {(inputs: Val_Public_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общественное достояние`)
};

const pt_val_public_domain = /** @type {(inputs: Val_Public_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domínio Público`)
};

const ko_val_public_domain = /** @type {(inputs: Val_Public_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`퍼블릭 도메인`)
};

/**
* | output |
* | --- |
* | "Public Domain" |
*
* @param {Val_Public_DomainInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_public_domain = /** @type {((inputs?: Val_Public_DomainInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Public_DomainInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_public_domain(inputs)
	if (locale === "es") return es_val_public_domain(inputs)
	if (locale === "fr") return fr_val_public_domain(inputs)
	if (locale === "de") return de_val_public_domain(inputs)
	if (locale === "ja") return ja_val_public_domain(inputs)
	if (locale === "zh") return zh_val_public_domain(inputs)
	if (locale === "ar") return ar_val_public_domain(inputs)
	if (locale === "id") return id_val_public_domain(inputs)
	if (locale === "it") return it_val_public_domain(inputs)
	if (locale === "ru") return ru_val_public_domain(inputs)
	if (locale === "pt") return pt_val_public_domain(inputs)
	return ko_val_public_domain(inputs)
});